import React from 'react';
import './PriceList.css';
import moonsKit from './../../assets/img/moonsKit.png';
import headerImage from './../../assets/img/price-list-header.png';
import PriceListTier from '../Components/Presentation/PriceListTier/PriceListTier';

class PriceList extends React.Component {
  render() {
    return (
        <div className="container pricelist-container">
            <div className="row pricelist header">
                <div className="col-md-5 col-md-offset-1">
                    <div>
                        <h2 className="title">Esquema de precios</h2>
                        <p className="content">
                            Te ofrecemos 4 opciones de tratamiento según 
                            la complejidad de cada caso. Nuestro equipo de ortodoncistas te 
                            recomendará un número de alineadores por caso, pero puede ser modificado por ti. 
                        </p>
                    </div>
                </div>
                <div className="col-md-5 text-right">
                    <img className="img-responsive header-image hidden-xs" src={headerImage} alt="moons"></img>
                </div>
            </div>

            <div className="row">
                <div className="vertical-separator-30px"></div>
                
                <div className="col-md-3">
                    <PriceListTier
                        name="Básico"
                        price="8,000"
                        aligners="18"
                        recommendedPrice="$23,990.00"
                    />
                </div>
                <div className="col-md-3">
                    <PriceListTier
                        name="Sencillo"
                        price="13,990"
                        aligners="28"
                        recommendedPrice="$23,990.00"
                    />
                </div>
                <div className="col-md-3">
                    <PriceListTier
                        name="Moderado"
                        price="16,500"
                        aligners="40"
                        recommendedPrice="$40,000.00"
                    />
                </div>
                <div className="col-md-3">
                    <PriceListTier
                        name="Severo"
                        price="18,500"
                        aligners="60"
                        recommendedPrice="$45,000.00"
                    />
                </div>
            </div>
        
            <div className="vertical-separator-50px"></div>
            
            <div className="row">
                <div className="col-md-6">
                    <img alt="moons" src={moonsKit} className="img-responsive"></img>
                </div>
                <div className="col-md-6">
                    <div className="vertical-separator-50px"></div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <h5 className="pricelist info title">Información de pago</h5>
                                    <p className="pricelist info">
                                        Grupo Dental Tecnológico Mexicano SAPI de CV
                                        Colima 220, Roma Norte, Cuauhtémoc, CDMX, 06700
                                    </p>
                                    <p>
                                        BBVA
                                        No. de cuenta: 01128756758
                                        CLABE: 012180001128756758
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="vertical-separator-50px"></div>

                            <div className="row">
                                <div className="col-md-6">
                                    <h5 className="pricelist info title">Contacto y soporte</h5>
                                    <p className="pricelist info">
                                        Movil: 5611788557
                                        Correo: drmoons@mymoons.mx
                                        Oficinas: Colima 220, Roma Norte, CDMX.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="vertical-separator-40px"></div>

        </div>
    )
  }
}

export default PriceList;



// WEBPACK FOOTER //
// ./src/views/Info/PriceList.js